package com.bitterinfant.shared

/** A single piece of media (video, audio, or image) used across the sites. */
data class MediaItem(
    val title: String,
    val description: String = "",
    /** File paths relative to /media, most-preferred format first (e.g. webm before mp4). */
    val sources: List<MediaSource>,
    /** Poster/thumbnail image path, used for videos and as a fallback. */
    val posterPath: String? = null,
)

enum class MediaKind { VIDEO, AUDIO, IMAGE }

data class MediaSource(
    val path: String,
    val mimeType: String,
    val kind: MediaKind,
)

data class Project(
    val title: String,
    val role: String,
    val year: String,
    val summary: String,
    val media: MediaItem? = null,
    val links: List<LinkRef> = emptyList(),
)

data class LinkRef(val label: String, val url: String)

data class ResumeEntry(
    val heading: String,
    val subheading: String,
    val period: String,
    val bullets: List<String> = emptyList(),
)

/** Content shared by the site header/footer across all three properties. */
object SiteLinks {
    const val STUDIO = "https://www.bitterinfantproductions.com"
    const val MATTHEW = "https://matthewthies.bitterinfantproductions.com"
    const val LAURA = "https://laurasteele.bitterinfantproductions.com"
}
